import { render, staticRenderFns } from "./ComponentLinkOrTransformButton.vue?vue&type=template&id=47840c5f&"
import script from "./ComponentLinkOrTransformButton.vue?vue&type=script&lang=js&"
export * from "./ComponentLinkOrTransformButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports